<template>
  <div class="no-active-campaign">
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          АНГЕЛ
        </div>
      </div>
      <div class="info-box-content">
        носи<br>
        вестта
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          ЛЪЧ
        </div>
      </div>
      <div class="info-box-content">
        надежда
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          ХРИСТОС
        </div>
      </div>
      <div class="info-box-content">
        се роди
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "christmas24st-slogan-component"
}
</script>

<style scoped>
.info-box {
  width: 300px;
}

.info-box-title {
  flex-basis: 120px;
  height: 80px;
  font-size: 1rem;
}

.info-box-content {
  align-self: center;
}
</style>
